define.alias("ember-basic-dropdown/components/basic-dropdown-content", "settings/components/basic-dropdown-content");